<script setup lang="ts">
import { NavigationBreadcrumbs } from '@shared/ui/menus'

import { useDisciplineDetailHeader } from '../model/discipline-detail-header.hook'

defineOptions({
  name: 'DisciplineDetailHeader',
})

const {
  config,
} = useDisciplineDetailHeader()
</script>

<template>
  <NavigationBreadcrumbs
    :config="config"
  />
</template>